/**
 * Filter items based on allowedList, disallowedList, and optional substance use criteria
 *
 * @param {Array} items - The array of items to filter
 * @param {Array} allowedList - Array of allowed item labels. If empty, all items are allowed (except disallowedListed ones)
 * @param {Array} disallowedList - Array of disallowed item labels
 * @param {Function} labelMapper - Function to extract the label from an item
 * @param {boolean} hideSubstanceUseTerms - When true, filters out items with primaryFocus of 'Substance Use'
 * @param {Object} primaryFocusMap - Map of item labels to their primary focus category
 * @returns {Array} - Filtered array of items
 */
const getAllowedFilters = (
  items,
  allowedList,
  disallowedList,
  labelMapper,
  hideSubstanceUseTerms = false,
  primaryFocusMap
) => {
  return items.filter(
    (i) =>
      (allowedList.length === 0 || allowedList.includes(labelMapper(i))) &&
      !disallowedList.includes(labelMapper(i)) &&
      (!hideSubstanceUseTerms ||
        primaryFocusMap[labelMapper(i)] !== 'Substance Use')
  )
}

export default getAllowedFilters
